<div [ngbPopover]="tooltipString" container="body" popoverClass="CXoneMgtPopover" placement="top" triggers="mouseenter:mouseleave">
    {{firstCellDisplayed}} <span *ngIf="tooltipLength > 0" style="color: #758994;">+{{tooltipLength.toString()}}</span>
</div>

